import { CommonFragments } from './common.fragments';

export class CharacteristicsFragments {
  /*
   * GraphQL Fragment for the Characteristics Exhibit
   */
  public static readonly characteristicsFragment = `
    metadata {
      portfolioName
    }
    yieldsDividendsExhibit {
      asOfDate
      benchmarkName
      portfolioCharacteristics {
        value
        asOfDate
        title
        benchmarkValue
        rank
        valueFormat
        tooltip
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;
}
